import { PROSPECT_ENDPOINTS } from "../../../../../../utils/api/endpoints/prospectEndpoints";

const PREFIX = '[uploadExcelKompassQuery]';

export const UPLOAD_KOMPASS_QUERY_KEY = 'UPLOAD_KOMPASS';

export const queryUploadExcelKompass = async (data: FormData) => {
  console.log(PREFIX, `Requesting excel KOMPASS uploading...`);

  const response = await PROSPECT_ENDPOINTS.assignFromExcel(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received excel KOMPASS response.`);
  return json as any;
};
